/**
 * Agent-approval analytics — Zod schemas (the governance dashboard aggregate).
 *
 * The response is the contract's ApprovalAnalyticsResponse, generated into api.generated.ts by make docs;
 * this module never restates it. Server-aggregated: the dashboard never sums the row list
 * client-side. `approved` includes 'consumed' (the normal terminal state once the agent acts on its
 * approval), one definition shared by the funnel, trend and per-agent breakdown, so
 * total = approved + denied + expired + pending.
 */

import { z } from "zod";

import {
  agentApprovalCountSchema,
  analyticsWindowSchema as approvalAnalyticsWindowSchema,
  approvalAnalyticsSchema,
  approvalDayCountSchema,
  approvalTotalsSchema,
} from "./api.generated";

export {
  agentApprovalCountSchema,
  approvalAnalyticsSchema,
  approvalAnalyticsWindowSchema,
  approvalDayCountSchema,
  approvalTotalsSchema,
};
export type ApprovalTotals = z.infer<typeof approvalTotalsSchema>;
export type AgentApprovalCount = z.infer<typeof agentApprovalCountSchema>;
export type ApprovalDayCount = z.infer<typeof approvalDayCountSchema>;
export type ApprovalAnalyticsWindow = z.infer<typeof approvalAnalyticsWindowSchema>;
export type ApprovalAnalytics = z.infer<typeof approvalAnalyticsSchema>;

// Window presets the dashboard offers (days back from now). URL-driven via ?days.
export const analyticsWindowSchema = z.object({
  days: z.coerce.number().int().refine((n) => [7, 30, 90].includes(n)).optional(),
});
export type AnalyticsWindow = z.infer<typeof analyticsWindowSchema>;
